import { EXCLUSION_RELATED_CLASSES } from '../constants';

export function isElementInsideWidget(element: HTMLElement): boolean {
  let currentElement: HTMLElement | null = element;

  while (currentElement) {
    const node = currentElement;

    if (
      EXCLUSION_RELATED_CLASSES.some((className) =>
        node.classList.value.includes(className)
      )
    ) {
      return true;
    }

    currentElement = currentElement.parentElement;
  }

  return false;
}
